"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.WalletButton = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WalletButton = function WalletButton(_ref) {
  var info = _ref.info,
      onClick = _ref.onClick;
  return /*#__PURE__*/_react.default.createElement("button", {
    onClick: onClick,
    className: "ws-xcard bg-white ws-flex ws-flex-col ws-p-2 ws-justify-center ws-items-center ws-rounded-md ws-shadow ws-hover:shadow-md ws-focus:outline-none"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: info.logo,
    className: "ws-object-center ws-object-cover ws-rounded-full ws-h-20 ws-w-20"
  }), /*#__PURE__*/_react.default.createElement("p", {
    className: "ws-text-lg ws-font-bold"
  }, info.name));
};

exports.WalletButton = WalletButton;
var _default = WalletButton;
exports.default = _default;